import { ContentFieldRow } from './content_field_row';
import { HeaderFieldRow } from './header_field_row';

export const CustomFieldRows = {
    ContentFieldRow,
    HeaderFieldRow
};